import React from 'react';
import clsx from 'clsx';
import { Button, Card, CardContent, CardActions, Typography } from '@material-ui/core';
import LazyLoad from 'react-lazyload';
import { Hero } from "../Hero/index.js";
import { useStyles } from "./styles.js";
export const NotFoundCard = ({
  id,
  component,
  to,
  image,
  message,
  btnLabel,
  className
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Hero, {
    id: id,
    clip: "none"
  }, /*#__PURE__*/React.createElement(Card, {
    className: clsx(classes.card, className)
  }, /*#__PURE__*/React.createElement(CardContent, null, image ? /*#__PURE__*/React.createElement(LazyLoad, null, /*#__PURE__*/React.createElement("img", {
    alt: "404 not found",
    src: image,
    className: classes.cardImg
  })) : /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h1",
    color: "primary"
  }, "404"), /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h6",
    component: "h2",
    gutterBottom: true
  }, message), /*#__PURE__*/React.createElement(CardActions, {
    className: classes.cardActions
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    align: "center",
    variant: "outlined",
    component: component,
    to: to
  }, btnLabel)))));
};
NotFoundCard.defaultProps = {
  to: '/',
  message: '¡Ups! Something went wrong',
  btnLabel: 'Back to home'
};
NotFoundCard.displayName = 'NotFoundCard';
export default NotFoundCard;